import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Card from "../../../components/Cards/Card";
import { CustomSearchBox } from "../../../components/CustomControls/CustomSearchBox";
import FrequentConceptsTable from "../../../components/Settings/FrequentConceptsTable";
import FrequentConceptUsageForm from "../../../components/Settings/FrequentConceptUsageForm";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";
import { Success } from "../../../components/Notifications/Notifications";
import { setConceptUsage } from "../../../api/snomed";
import { useConceptUsages } from "./Hooks";

export default function FrequentConceptsContainer() {
    const { t } = useTranslation();

    const [query, setQuery] = useState({
        term: "",
        pageSize: 10,
        pageIndex: 0,
        reloadToken: 0,
    });
    const [editing, setEditing] = useState(null);

    const [items, isLoading, totalSize] = useConceptUsages(query);

    const handleSearch = (q) => {
        setQuery(prev => ({ ...prev, term: q, pageIndex: 0 }));
    };

    const handleTableChange = (_type, { page, sizePerPage }) => {
        setQuery(prev => ({ ...prev, pageIndex: page - 1, pageSize: sizePerPage }));
    };

    const handleEdit = (concept) => {
        setEditing(concept);
    };

    const handleFormSubmit = async (usageCount) => {
        try {
            await setConceptUsage(editing.id, usageCount);
            Success("settingsNotifications.settings_Updated");
            setEditing(null);
            setQuery(prev => ({ ...prev, reloadToken: prev.reloadToken + 1 }));
        }
        catch (error) {
            HandleApiError(error);
        }
    };

    return (
        <>
            <Card
                tabs
                header={
                    <Row>
                        <Col md={4}>
                            <CustomSearchBox handleSearch={handleSearch} placeholder={t('settings.settings.frequentConcepts.searchPlaceholder')} />
                        </Col>
                    </Row>
                }
                content={
                    <FrequentConceptsTable
                        data={items ?? []}
                        query={query}
                        totalSize={totalSize}
                        onTableChange={handleTableChange}
                        isLoading={isLoading}
                        onEdit={handleEdit}
                    />
                }
            />
            {editing && (
                <FrequentConceptUsageForm
                    concept={editing}
                    onSubmit={handleFormSubmit}
                    onCancel={() => setEditing(null)}
                />
            )}
        </>
    );
}
